import { feedList } from "@/mocks/gossip";

const labelStyle: Record<string, string> = {
  新瓜: "bg-orange-500 text-white",
  进展: "bg-emerald-600 text-white",
  求证: "bg-stone-200 text-stone-700",
  补料: "bg-amber-500 text-white",
};

export default function Feed() {
  return (
    <section id="feed" className="scroll-mt-20 bg-white">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-xl font-extrabold text-stone-900 md:text-2xl">
              新瓜速递
              <span className="inline-flex h-2 w-2 rounded-full bg-orange-500"></span>
            </h2>
            <p className="mt-1.5 text-sm text-stone-600">按发布时间倒序，今天的新瓜与进展一条不漏。</p>
          </div>
          <a
            href="#faq"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap text-sm font-medium text-emerald-700 hover:text-emerald-800"
          >
            看更新规则 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          {feedList.map((item, idx) => (
            <article
              key={idx}
              className="group flex flex-col gap-3 rounded-xl border border-stone-200/80 bg-[#FFFDF8] p-4 transition-colors hover:border-emerald-300 sm:flex-row sm:items-start md:p-5"
            >
              <div className="flex shrink-0 items-center gap-1 text-xs text-stone-400 sm:w-28 sm:pt-0.5">
                <i className="ri-time-line"></i>
                <span className="whitespace-nowrap">{item.time}</span>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold ${labelStyle[item.label]}`}>
                    {item.label}
                  </span>
                  <span className="text-xs text-stone-400">{item.tag}</span>
                </div>
                <h3 className="mt-2 text-[15px] font-bold leading-snug text-stone-900 group-hover:text-emerald-700 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-stone-500">{item.summary}</p>
              </div>

              <div className="flex shrink-0 flex-row items-center gap-3 text-xs text-stone-400 sm:flex-col sm:items-end sm:gap-2">
                <span className="whitespace-nowrap">{item.count}</span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-emerald-700">
                  展开 <i className="ri-arrow-right-s-line text-lg leading-none"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}